import {
  CorePagination,
  CoreSearch
} from '@komodo-design-system/komodo-components-react';
import Table from 'componentsV2/Table/Table';
import React from 'react';
import Loading from 'components/Placeholders/Loading';
import './JobsTable.scss';
import { REFRESH_BUTTON_TITLE } from 'constants/constants';
import { dateFormatter } from 'utils/utils';
import Filter from '../Filter/Filter';
import { useJobsTable } from './useJobsTable';
import { isEmpty } from 'lodash-es';
import AlertBox from 'componentsV2/SharedAlertBox/AlertBox/AlertBox';

const JobsTable = () => {
  const {
    // State
    pageNumber,
    rpp,
    pageSize,
    selectedStatus,
    setSelectedStatus,
    selectedJob,
    setSelectedJob,
    sorting,
    searchInput,
    filteredResults,
    isLoading,
    error,
    uniqueStatuseswithLabels,
    uniqueJobswithLabels,
    rppList,
    alert,
    setAlert,
    loading,
    // Handlers
    searchHandler,
    handleRefreshClick,
    handleCellClick,
    handleDownloadTemplate,
    handleSortingChange,
    handleActivePageChange,
    searchItems,
    handleResultsPerPageChange,
    handleClearSearch
  } = useJobsTable();

  const columns = [
    {
      header: 'Job Name',
      accessor: 'jobName',
      sortable: true,
      cell: (row: any) => <span>{row?.jobName}</span>,
      onCellClick: (value: any, accessor: any, row: any) =>  !isEmpty(row?.jobsConsolidatedStatus) && handleCellClick(value, accessor, row),
      cellClassName: (row: any) =>
        isEmpty(row?.jobsConsolidatedStatus) ? 'disable-link' : ''
    },
    {
      header: 'Bulk Job ID',
      accessor: 'bulkUploadId',
      sortable: true,
      cell: (row: any) => {
        return (
          <span
            // style={{ width: '25%' }}
          >
            {row?.bulkUploadId}
          </span>
        );
      }
    },
    {
      header: 'Source File',
      accessor: 'fileName',
      sortable: true,
      cell: (row: any) => (
        <span 
          style={{
            display: 'block',
            maxWidth: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={row?.fileName}
        >
          {row?.fileName}
        </span>
      )
    },
    {
      header: 'Start Date',
      accessor: 'uploadedDate',
      sortable: true,
      cell: (row: any) => <span>{dateFormatter(row?.uploadedDate)}</span>
    },
    {
      header: 'End Date',
      accessor: 'completedDate',
      sortable: true,
      cell: (row: any) => <span>{dateFormatter(row?.completedDate)}</span>
    },
    {
      header: 'Status',
      accessor: 'status',
      sortable: true,
      cell: (row: any) => {
        const status = row?.status?.toLowerCase() || 'failed';
        const formattedStatus = status.replaceAll('_', ' ');
        return (
          <span style={{ padding:'6px', borderRadius:'15px',color: 'white' }} className={status}>
            {formattedStatus.charAt(0).toUpperCase() + formattedStatus.slice(1).toLowerCase() || 'Failed'}
          </span>
        );
      }
    },
    {
      header: 'Assets Count',
      accessor: 'assetCount',
      sortable: true,
      cell: (row: any) => <span style={{ paddingLeft:'6px'}}>{row?.assetCount}</span>
    },
    {
      header: 'Error File',
      accessor: 'errorMessage',
      sortable: true,
      cell: (row: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          {/* <span 
            style={{
              display: 'block',
              maxWidth: '180px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1
            }}
            title={row?.errorMessage}
          >
            {row?.errorMessage}
          </span> */}
          {row?.errorFilePath && (
            <span
              className={`link-button`}
              onClick={() => handleDownloadTemplate(row.errorFilePath)}
            >
              <span>Download</span>
            </span>
          )}
        </div>
      )
    }
  ];

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="jobs-container">
      <div className="title-container">
        <div className="page-title">My Jobs</div>{' '}
        <span
          className="icon-24-refresh-bold"
          onClick={handleRefreshClick}
          title={REFRESH_BUTTON_TITLE}></span>{' '}
      </div>
      <div className="search_block">
        <div className="search-filter-container">
          <div className="search-section">
            <div className="search-wrapper">
              <CoreSearch
                id="coreSearch"
                placeholder="Search by Job Name or Status (Min.3 characters)"
                title="Search by Job Name or Status (Min.3 characters)"
                onSearchCleared={handleClearSearch}
                onSearchQueryChanged={(e) => searchItems(e.detail.trim())}
                onSearchEnterPress={() => searchHandler()}
                clearicon
                bold
              />
              {filteredResults?.records?.length === 0 && searchInput.length > 0 && (
                <div className="search-results">
                  <span className="errorMsg">
                    <span className="icon-16-warning-mono"></span>
                    Sorry, no matching record found
                  </span>
                </div>
              )}
              { filteredResults?.records?.length === 0 && searchInput.length === 0 && (
                <div style={{ paddingTop: '10px'}}>
                    No data available
                </div>
              )}
            </div>
          </div>
          
          <div className="filter-section">
            <div className="filter-wrapper">
              <Filter
                selectedStatus={selectedStatus}
                selectedJob={selectedJob}
                setSelectedStatus={setSelectedStatus}
                setSelectedJob={setSelectedJob}
                uniqueStatuseswithLabels={uniqueStatuseswithLabels}
                uniqueJobswithLabels={uniqueJobswithLabels}
              />
            </div>
          </div>
        </div>
      </div>
      {isLoading ? <Loading/> : filteredResults?.records?.length > 0 &&(
        <>
          <Table
            sorting={sorting}
            data={filteredResults?.records || []}
            columns={columns}
            onSortingChange={handleSortingChange}
          />
          {filteredResults?.totalRecords > pageSize && rppList.length > 0 && selectedJob.length === 0  && selectedStatus.length === 0 && (
            <CorePagination
              variants={{ dropdown: true, indicator: false, goto: false }}
              resultsperpage={rppList}
              totalresults={filteredResults?.totalRecords}
              activepage={pageNumber || 1}
              activeresultsperpage={rpp}
              onResultsPerPageChange={(event) => handleResultsPerPageChange(event.detail)}
              onActivePageChange={(event) => handleActivePageChange(event.detail.activePage)}
            />
          )}
        </>
      )
      }
      {alert.open && <AlertBox
        message={alert.message}
        isModalOpen = {alert.open}
        handleClose={()=>setAlert({open: false, message: ''})}
      />}
      {loading && <Loading />}
    </div>
  );
};

export default JobsTable;
